export const Finance = () => (
  <span role="img" aria-label="finance" className="anticon  ant-menu-item-icon">
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00308 14.732C7.93108 17.216 9.11908 18.332 11.7471 18.404C14.5551 18.44 15.8151 17.18 15.6711 14.768C15.4551 12.68 13.4391 12.14 11.8551 11.924C10.1271 11.312 8.29108 11.024 8.29108 8.50398C8.29108 6.77598 9.44308 5.65998 11.8551 5.69598C14.0151 5.69598 15.3471 6.59598 15.3111 8.71998"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path d="M11.7831 3.5V20.5Z" fill="currentColor" />
      <path d="M11.7831 3.5V20.5" stroke="currentColor" />
    </svg>
  </span>
);
